<template>
  <div v-if="kycDone==true && isParty==false && isGov==false && blocked==false">
    <KYCDetails></KYCDetails>
  </div>
  <div v-else-if="kycDone==true && isParty==false && isGov==false && blocked==true">
    <Blocked></Blocked>
  </div>
  <div
    v-else-if="kycDone==false && isParty==false && isGov==false && isOwner==false && inProcess==false "
  >
    <before></before>
  </div>
  <div
    v-else-if="kycDone==false && isParty==false && isGov==false && isOwner==false && inProcess==true"
  >
    <KYCDone></KYCDone>
  </div>
  <div v-else-if="isParty==true">
    <KYCDetailsParty></KYCDetailsParty>
  </div>
  <div v-else-if="isGov==true">
    <KYCDetailsGov></KYCDetailsGov>
  </div>
  <div v-else-if="isOwner==true">
    <Admin></Admin>
  </div>
</template>
<script>

import axios from "axios";

export default {
  data() {
    return {
      kycDone: undefined,
      isParty: undefined,
      isGov: undefined,
      isOwner: undefined,
      inProcess: false,
      blocked: false,
      currentAddress:this.$cookies.get('address')
    };
  },
  name: "Home",
  components: {
    before: () => import("../views/beforeKYC.vue"),
    KYCDetails: () => import("./KYCDetails.vue"),
    KYCDetailsGov: () => import("./KYCDetailsGov.vue"),
    KYCDetailsParty: () => import("./KYCDetailsParty.vue"),
    Admin: () => import("./Admin.vue"),
    KYCDone: () => import("../views/KYCDone.vue"),
    Blocked: () => import("../views/Blocked.vue")
  },
  methods: {
    async checkStatus() {
      this.$store.state.loading = true;
      let acc = this.$cookies.get('address');
      console.log("accounts:",acc)
      let isParty = await this.$store.state.KYC.isParty(acc).call();
      // console.log("is nparty:", isParty);
      if (isParty == false) {
        this.isParty = false;
        let isGov = await this.$store.state.KYC.isGov(acc).call();
        // console.log("is gov:", isGov);
        if (isGov == false) {
           let owner = await this.$store.state.KYC.Owner().call();
           owner=await this.$store.state.tronWeb.address.fromHex(owner);
          // console.log()
          //  let owner2=await this.$store.state.KYC.Owner2().call();
          // console.log(owner);
          let admin = await this.$store.state.KYC.isAdmin(acc).call();
          if (owner == acc  || admin == true) {
            this.isOwner = true;
          }
          else{ 
               this.isOwner = false
          let status = await this.$store.state.KYC.KYCDone(acc).call();
          console.log(status)
        
          this.kycDone = status;
          this.blocked = await this.$store.state.KYC.blocked(acc).call();
          if (status == false) {
            let key = process.env.VUE_APP_API_KEY;
            let newStatus = await axios({
              url:
              this.$store.state.url+"/api/user/getKycStatus/" +
               this.currentAddress,
              method: "GET",

              headers: {
                Authorization: "Basic " + key
              }
            });
           console.log(newStatus)
            if (newStatus.data) {
              this.inProcess = true;
              this.$store.state.loading = false;
            }
          }

         
          }
           this.isGov = false;
          
        } else if (isGov == true) {
          this.isGov = true;
        }
      } else if (isParty == true) {
        console.log("hm")
        this.isParty = true;
      }
       
    }

  
  },
  async created() {
   
            
          
           
    await this.checkStatus();

     
  }
};
</script>

